/**
 * Copyright (c) 2026, CheckPlus Limited
 */

export const getProjectTitle = (language, mission) => {
  if (!mission) return "";
  if (mission.titleI18n && language && mission.titleI18n[language]) {
    return mission.titleI18n[language];
  }
  return mission.title || "";
};

/**
 * The project label for one payment row.
 *
 * projectName — the project's title copied onto the payment when it was made —
 * comes first, deliberately, ahead of the project's *current* title. Orgs reuse
 * projects: an annual flag day gets renamed and run again, so the current title
 * can describe a different campaign than the one this payment was actually given
 * to. Labelling old payments with it would misattribute money between campaigns,
 * and would disagree with the receipt already issued to the donor, which carries
 * the name as it stood that day.
 *
 * The loaded project list is only a fallback, for the rare payment with no stored
 * name. It holds one page of projects, so it frequently will not have the one
 * being looked for — which is the whole of CP-274. Returning "" on that miss is
 * what kept the bug invisible for fifteen months: an empty label is
 * indistinguishable from a payment that genuinely has no project, so it reads as
 * correct. Only return "" with nothing left to try.
 */
export const getPaymentProjectLabel = (language, payment, missions) => {
  if (!payment) return "";

  if (payment.projectName) return payment.projectName;

  if (payment.projectId && Array.isArray(missions)) {
    const mission = missions.find((m) => m.id === payment.projectId);
    if (mission) return getProjectTitle(language, mission);
  }

  return "";
};
